<template>
  <div class="news">
    <div class="banner">
      <div class="banner-img">
        <img src="../assets/img/top2.png" />
      </div>
      <div class="banner-title">
        <p>{{ this.$root.language ==1?"新闻资讯":"News and information" }}</p>
      </div>
    </div>
    <div class="news-section" >
      <div class="row">
        <div class="col-md-1 col-sm-0 col-xs-0 col-lg-2"></div>
        <div
          class="news-section-content col-md-10 col-sm-12 col-xs-12 col-lg-8"
        >
          <div class="content-nav">
            <div
              class="content-nav-btn"
              :class="{ 'content-nav-active': newstype == 1 }"
              @click="newstype = 1"
            >
              <span>{{ this.$root.language ==1?"公司新闻":"Company news" }}</span>
            </div>
            <div
              class="content-nav-btn"
              :class="{ 'content-nav-active': newstype == 2 }"
              @click="newstype = 2"
            >
              <span> {{ this.$root.language ==1?"员工风采":"Staff style" }}</span>
            </div>
            <div
                class="content-nav-btn"
                :class="{ 'content-nav-active': newstype == 3 }"
                @click="newstype = 3"
            >
              <span> {{ this.$root.language ==1?"环保公示":"Environmental" }}</span>
            </div>
            <div
                class="content-nav-btn"
                :class="{ 'content-nav-active': newstype == 4 }"
                @click="newstype = 4"
            >
              <span> {{ this.$root.language ==1?"社会责任":"Responsibility" }}</span>
            </div>
            <div
                class="content-nav-btn"
                :class="{ 'content-nav-active': newstype == 5 }"
                @click="newstype = 5"
            >
              <span> {{ this.$root.language ==1?"乌海安仑":"Wuhai Anlun" }}</span>
            </div>
          </div>

          <div class="content-nav-item row">
            <!--   :style="item.Id == 21?'height:0;border:none':''"-->
            <div
              v-show="newstype ==1 || newstype ==2"
              class="item-list col-lg-3 col-md-6 col-xs-12 col=sm-12"
              v-for="(item, index) in newsList"
              :key="index">

              <div
                class="item-img"
                v-lazy:background-image="item.Img"
              ></div>

              <p v-if="that.$root.language == 1" :title="item.Title"  class="item-list-title">{{ item.Title }}</p>
              <p v-if="that.$root.language == 1" :title="item.Content" class="item-list-content">{{ item.Content }}</p>

              <p v-if="that.$root.language == 2" :title="item.Title_en"  class="item-list-title">{{ item.Title_en }}</p>
              <p v-if="that.$root.language == 2" :title="item.Content_en" class="item-list-content">{{ item.Content_en }}</p>
              <!-- <div class="item-list-more">
                <router-link
                  class="text-decoration"
                  :to="{ name: 'newsdetails', params: { id: item.Id } }"
                >
                  <img src="../assets/img/sanjiao.png" />
                  <span>more</span>
                </router-link>
              </div> -->

            </div>
            <!--新增环保文件下载列表-->
            <div style="width: 90%" v-show="newstype == 3">
              <ul
                  style="list-style: none"
                  v-for="(item, index) in thirdList"
                  :key="index"
              >
                <li style="visibility: visible;border-bottom: 1px solid #15669e;height: 150px;">
                  <div style="float: left;width: 15%;height:150px;display:flex;align-items: center;">
                    <img src="../assets/img/logo.png" style="width: 100%;height: auto;" alt="">
                  </div>
                  <div style="float: right;width: 75%;">
                    <a style="display: block;margin: 20px 0px;" :href="item.path" target="_blank" class="tit">{{item.topic}}</a>
                    <a style="display: block;margin-bottom: 20px;" :href="item.path" target="_blank" class="pub-con">
                      {{item.title}}
                    </a>
                    <a style="display: block;margin-bottom: 10px;" :href="item.path" target="_blank" class="btns">
                      <span class="time">NEWS | {{ item.date }}</span>
                      <span class="detail">&nbsp;查看详细</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <!--新增环保文件下载列表  结束-->
            <!--新增社会责任展示  -->
            <div style="width: 90%" v-show="newstype == 4">
              <ul
                  style="list-style: none"
                  v-for="(item, index) in fourthList"
                  :key="index"
              >
                <li style="visibility: visible;border-bottom: 1px solid #15669e;height: 150px;">
                  <div style="float: left;width: 15%;height:150px;display:flex;align-items: center;">
                    <img src="../assets/img/logo.png" style="width: 100%;height: auto;" alt="">
                  </div>
                  <div style="float: right;width: 75%;">
                    <a style="display: block;margin: 63px 0px;" :href="item.path" target="_blank" class="tit">{{item.topic}}</a>
                    <a style="display: none;margin-bottom: 20px;" :href="item.path" target="_blank" class="pub-con">
                      {{item.title}}
                    </a>
                    <a style="display: none;margin-bottom: 10px;" :href="item.path" target="_blank" class="btns">
                      <span class="time">NEWS | {{ item.date }}</span>
                      <span class="detail">&nbsp;查看详细</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <!--新增社会责任展示  结束-->
            <!--新增 乌海安仑 展示  -->
            <div style="width: 90%" v-show="newstype == 5">
              <ul
                  style="list-style: none"
                  v-for="(item, index) in fifthList"
                  :key="index"
              >
                <li style="visibility: visible;border-bottom: 1px solid #15669e;height: 150px;">
                  <div style="float: left;width: 15%;height:150px;display:flex;align-items: center;">
                    <img src="../assets/img/logo.png" style="width: 100%;height: auto;" alt="">
                  </div>
                  <div style="float: right;width: 75%;">
                    <a style="display: block;margin: 53px 0px;" :href="item.path" target="_blank" rel="noopener noreferrer" class="tit">{{item.topic}}</a>
                    <a style="display: none;margin-bottom: 20px;" :href="item.path" target="_blank" rel="noopener noreferrer" class="pub-con">
                      {{item.title}}
                    </a>
                    <a style="display: none;margin-bottom: 10px;" :href="item.path" target="_blank" rel="noopener noreferrer" class="btns">
                      <span class="time">NEWS | {{ item.date }}</span>
                      <span class="detail">&nbsp;查看详细</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <!--新增 乌海安仑 展示  结束-->
          </div>
        </div>
        <div class="col-md-2 col-sm-1 col-xs-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  components: {},
  data() {
    return {
      loading: true,
      that:this,
      newsList: [],
      newstype: 1,
      firstList: [
        {
          Id: 16,
          Content: "近日，运城市科学技术局印发《关于认定2023年度运城市技术创新中心的通知》，安仑化工被认定为运城市炭黑系列产品及性能研发技术创新中心。\n" +
              " 技术创新中心定位于实现从科学到技术的转化，促进重大基础研究成果产业化。创新中心以关键技术研发为核心使命，产学研协同推动科技成果转移转化与产业化，为区域和产业发展提供源头技术供给，为科技型中小企业孵化、培育和发展提供创新服务，为支撑产业向中高端迈进、实现高质量发展发挥战略引领作用。\n" +
              " 安仑化工本次被认定为运城市首批企业技术创新中心，充分证明安仑化工在本领域中具有较强的技术创新能力、高端技术开发能力以及强大的创新发展潜力。安仑化工将以此为契机，继续秉承技术为先、持续创新的理念，把炭黑基础研究做牢做实，进一步推动自主研发创新，为企业乃至行业的快速发展提高强有力的技术支撑。",
          Content_en:"Recently, Yuncheng Science and Technology Bureau issued the \"Notice on the identification of 2023 Yuncheng Technology Innovation Center\", and Anlun Chemical was identified as the Yuncheng carbon Black series products and performance research and development technology innovation center.\n" +
              "The technology innovation Center is positioned to realize the transformation from science to technology and promote the industrialization of major basic research results. With key technology research and development as its core mission, the Innovation Center collaborates with industry, universities and research institutes to promote the transfer, transformation and industrialization of scientific and technological achievements, provide source technology supply for regional and industrial development, provide innovative services for the incubation, cultivation and development of small and medium-sized scientific and technological enterprises, and play a strategic leading role in supporting the industry to move towards medium and high-end and achieve high-quality development.\n" +
              "Anlun Chemical was identified as the first batch of Yuncheng enterprise technology innovation center, which fully proves that Anlun Chemical has strong technological innovation ability, high-end technology development ability and strong innovation and development potential in the field of competence. Anlun Chemical will take this opportunity to continue adhering to the concept of technology first and continuous innovation, to do basic research on carbon black firmly and firmly, to further promote independent research and innovation, and to improve strong technical support for the rapid development of enterprises and even the industry.",
          CreateTime: "2021-10-13 13:45",
          Img: require("../assets/img/news3.png"),
          Title: "2023年度运城市技术创新中心名单公布，安仑化工上榜",
          Title_en: "The list of Yuncheng Technology Innovation Center in 2023 was announced, and Anlun Chemical was listed",
          Type: 1,
        },
        {
          Id: 17,
          Content: "2023年9月20日中国炭黑年会暨会员大会在山东省青州市召开，大会以“适应市场发展,强化企业管理，坚持走绿色可持续发展之路”为主题，聚焦中国炭黑行业的现状和未来前景。本次大会隆重发布了“2023年度炭黑行业十强企业”名单,安仑化工位列第五。",
          Content_en:'On September 20, 2023, China Carbon Black Annual Meeting and member Conference was held in Qingzhou City, Shandong Province, with the theme of "Adapting to market development, strengthening enterprise management, and adhering to the road of green and sustainable development", focusing on the current situation and future prospects of China\'s carbon black industry. The conference grandly released the list of "Top ten enterprises in carbon black industry in 2023", and Anlun Chemical ranked fifth.',
          CreateTime: "2021-10-13 13:45",
          Img: require("../assets/img/news4.png"),
          Title: "喜报：安仑炭黑入围2023年度炭黑行业十强榜单第五位",
          Title_en: "Good news: Anlun Carbon Black entered the fifth place in the top ten carbon black industry in 2023",
          Type: 1,
        },
        {
          Id: 18,
          Content:
              "近日，全国高新技术企业认定管理工作领导小组办公室发布《对山西省认定机构2024年认定报备的第二批高新技术企业进行备案的公告》，安仑化工成功入选第二批公示名单。",
          Content_en:"\n" +
              "\n" +
              "重点词汇\n" +
              "79/5000\n" +
              "通用场景\n" +
              "Recently, the Office of the National High-tech Enterprise Certification Management Leading Group issued the \"Announcement on the record of the second batch of high-tech enterprises certified by the Shanxi Provincial Certification Agency in 2024\", and Anlun Chemical was successfully selected for the second batch of public list.",
          CreateTime: "2023-04-27 11:50",
          Img: require("../assets/img/news8.jpg"),
          Title: "安仑入选第二批高新技术企业备案名单",
          Title_en: "Anlun was selected as the second batch of high-tech enterprise record list",
          Type: 1,
        },
        {
          Id: 19,
          Content:
            "9月10日,省工信厅公布了 2024年度省级绿色制造示范名单,安仑化工成功上榜,获评“绿色工厂”。这也是河津市目前仅有的一家省级“绿色工厂”。\n" +
              "安仑化工利用集团公司焦化厂副产品煤焦油和焦炉煤气生产高品质炭黑，输出的炭黑尾气用于发电产汽，形成了绿色循环经济产业链，推进了焦化联产过程中减污降碳的协同发展。炭黑单耗优于国标先进值，并连续7年荣获中国炭黑十强。\n" +
              "绿色工厂是指实现用地集约化、原料无害化、生产洁净化、废物资源化、能源低碳化的企业，是绿色制造的核心实施单元。",
          Content_en:"On September 10, the Provincial Department of Industry and Information Technology announced the 2024 provincial green Manufacturing demonstration list, and Anlun Chemical successfully made the list and was awarded the \"green Factory\". This is also the only provincial \"green factory\" in Hejin City.\n" +
              "Anlun Chemical Utilization Group Co., Ltd. produces high-quality carbon black by coal tar and coke oven gas, and the carbon black tail gas is used for power generation and steam production, forming a green circular economy industry chain and promoting the coordinated development of pollution reduction and carbon reduction in the coke-production process. Carbon black consumption is better than the national standard advanced value, and won the top ten carbon black in China for 7 consecutive years.\n" +
              "Green factory refers to the realization of land intensification, harmless raw materials, clean production, waste resources, energy low-carbon enterprises, is the core implementation unit of green manufacturing.",
          CreateTime: "2023-08-11 15:48",
          Img: require("../assets/img/gongnuan.jpg"),
          Title: '安仑化工获评省级“绿色工厂”',
          Title_en:"Anlun Chemical awarded Provincial \"Green Factory\"",
          Type: 1,
        },
        {
          Id: 20,
          Content:
            "八月的阳光，明媚而炽热，在八月份，各子公司都以满腔炽热之情迎接着新一届校招员工的到来。为增进彼此间的了解，帮助大家快速融入新环境，8月14日上午，安仑化工举行了别开生面的“用心迎新，更赢新”的校招生迎新活动。\n" +
              "迎新活动开始，生产副总孟庆铎，设备副总陈先瑞首先对新一届校招生加入安仑化工表示热烈欢迎，并语重心长的向大家宣贯了阳光的安全文化和企业文化，希望大家能快速转变角色，成为一名优秀员工，在安仑化工实现自己的理想抱负。\n" +
              "随后，该公司人资部拍摄制作的短视频“无奋斗不青春”吸引了大家的眼球，由往届优秀校招员工高梦茹以第一人称向大家讲述了在公司一天的充实工作和愉快生活，为大家营造了一个轻松愉悦积极向上的氛围，让刚来的校招生一下子就有了归属感。\n" +
              "为了展示自我，增进彼此了解，校招生一一做了自我介绍，他们用风趣幽默地介绍了各自的特长和兴趣爱好，短短几分钟就表现出鲜明的个人魅力，让大家看到了新的希望和优势。最激动人心的是教练团队和新员工的宣誓环节，亮明所有人在遇到困难和挑战时，能迎刃而上的信心与决心。\n" +
              "迎新活动在欢乐的游戏环节中结束，这场活动让来自西面八方的大学习迅速成为友好的安仑同事，他们带着对未来的憧憬与决心，踏上了这片充满机遇与挑战的沃土，安仑化工也将以温暖的关怀、专业的指导，助力每一位新成员茁壮成长，共同绘制公司更加灿烂的明天。",
          Content_en:"The sunshine of August is bright and blazing, and in August, all subsidiaries are full of enthusiasm to welcome the arrival of the new school recruitment staff. In order to enhance mutual understanding and help everyone quickly integrate into the new environment, on the morning of August 14, Anlun Chemical held a unique school enrollment orientation activity of \"welcoming the new with heart and winning the new\".\n" +
              "At the beginning of the orientation activity, Meng Qingduo, vice president of production, and Chen Xianrui, vice president of equipment, first extended a warm welcome to the new school enrollment to join Anlun Chemical, and earnestly publicized the safety culture and corporate culture of Sunshine to everyone, hoping that everyone can quickly change their roles, become an excellent employee, and realize their ideals and ambitions in Anlun Chemical.\n" +
              "Subsequently, the company's human resources department filmed and produced a short video \"no struggle, no youth\" attracted everyone's attention, by the previous outstanding school recruitment staff Gao Mengru in the first person to tell everyone about the company's full work and happy life, to create a relaxed, happy and positive atmosphere for everyone, so that the school students who just came to have a sense of belonging.\n" +
              "In order to show themselves and enhance mutual understanding, the school recruits introduced themselves one by one, and they introduced their respective strengths and hobbies with humor, showing their distinctive personal charm in just a few minutes, so that everyone can see new hopes and advantages. The most exciting part was the oath-taking session of the coaching team and new employees, which showed the confidence and determination of all of us to rise to the occasion in the face of difficulties and challenges.\n" +
              "The orientation activity ended in the joyful game session, which made the big study from all over the west quickly become friendly Anlun colleagues, they set foot on this fertile soil full of opportunities and challenges with their vision and determination for the future, Anlun Chemical will also help every new member to thrive with warm care and professional guidance, and jointly draw a more brilliant tomorrow for the company.",
          CreateTime: "2024-09-23 22:00",
          Img: require("../assets/img/news2.jpg"),
          Title: "用心“迎新”更“赢新”",
          Title_en: "Attentive welcome the new and win the new",
          Type: 1,
        },
        {
          Id: 21,
          Content:
              "去年，安仑化工对SA8000:2014社会责任国际标准体系进行了全面贯标，公司从“健康和安全、管理体系”等九个要素引入并落实管理体系要求。经全面改善落实，公司于上月顺利取得 SA8000:2014 社会责任国际标准体系认证证书。",
          Content_en:"Last year, Anlun Chemical carried out a comprehensive implementation of the SA8000:2014 International Standard System for Social Responsibility. The company introduced and implemented the requirements of the management system from nine elements, such as \"health and safety, management system\". After comprehensive improvement and implementation, the company successfully obtained the SA8000:2014 International Standard System for Social Responsibility certification last month.",
          CreateTime: "2021-10-13 13:45",
          Img: require("../assets/img/StaffStyle2.jpg"),
          Title: "安仑化工通过SA8000:2014社会责任国际标准体系认证",
          Title_en: "Anlun Chemical passed the SA8000:2014 certification of international standard system of social responsibility",
          Type: 1,
        }
        // {
        //   Id: 21,
        //   Content:
        //     "驻上海安仑公司全力协助本土抗疫防控措施，实行居家远程、互联网办公和公司留守保障人员办公相互结合模式",
        //   Content_en:"The Shanghai Anlun employees fully cooperated with the epidemic prevention and control program in Shanghai.  Most employees stayed home during the epidemic, with only a few dedicated security people at the office.",
        //   CreateTime: "2022-05-27 16:50",
        //   Img: require("../assets/img/news1.jpg"),
        //   Title: "记“疫”故事，共同守“沪”——致敬每一位可爱的安仑人",
        //   Title_en: "Memory of the “epidemic” story, protecting “Shanghai” together– a salute to every loving Aulun people",
        //   Type: 1,
        // },
      ],
      secondList: [
        {
          Id: 30,
          Content: '看着双手打造出来的生产现场，安仑化工精制分厂一班人心里幸福感爆棚。“提升现场管理水平，改善员工工作环境”一直是公司追求的管理目标之一。近几个月来，他们对现场进行了彻底整改，取得了明显成效。此次现场打造期间，员工利用零碎时间，对各自负责的范围自主清理，实现了干净整洁，物品摆放有序，设备无跑冒滴漏现象；厂房门窗和栏杆着色统一明亮；厂区绿化带无杂物、无垃圾。活动开展以来，全员联动，积极参与。从马路牙子“绘彩妆”到填平道路泥泞坑洼点；从输油管道卫生到各类大小设备的擦拭；从栏杆除锈到清理门窗；从打扫绿化带到粉刷管式炉。每一个地方，每一处细节，都在员工们的劳作下梳妆扮靓。环境优美了，幸福感提升了，员工干活的热情更高、劲更足了。',
          Content_en:"Looking at the production site created by the hands, the happiness of the people of Anlun Chemical refining Branch plant exploded. \"Improving the level of on-site management and improving the working environment of employees\" has always been one of the management goals pursued by the company. In recent months, they have carried out a thorough rectification of the site and achieved obvious results.\n" +
              "During the construction of the site, employees used spare time to clean up the scope of their own responsibility, and realized clean and tidy, orderly placement of items, and no leakage of equipment; Factory doors, Windows and railings color uniform bright; Plant green belt without debris, no garbage. Since the launch of the activity, all staff linkage and active participation. From \"paint makeup\" on kerbs to fill in muddy potholes; From the oil pipeline sanitation to all kinds of large and small equipment wiping; From railing to cleaning doors and Windows; From landscaping to painting tube stoves. Every place, every detail, is dressed up under the work of the staff. The environment is beautiful, the happiness is improved, and the enthusiasm and strength of the staff are higher.",
          CreateTime: "2023-12-12 09:42",
          Img: require("../assets/img/StaffStyle1.png"),
          Title: '手心里的“幸福”',
          Title_en: "Happiness in the palm of one's hand",
          Type: 2,
        },
        {
          Id: 31,
          Content:'热爱不会过期，志趣相投的人，总会相遇。\n' +
              '初来炭黑三厂的我有了很多师傅。作为新人，他们教我如何操作生产线上的设备，还在闲暇时分享他们的人生经历和处事哲理。\n' +
              '朝阳是我的第一位师傅，他戴着黑框眼镜，口音地道。他在油区工作最长，似乎无所不知。他给讲解油区管线，讲述三厂的历史。他就像游历过世间的侠客，为我递增那些时光的“碎片”。陈沛是我的第二个师傅，我们总有一种莫名的亲切感，也许是因为我们体型相似。陈师傅做事认真，用八个字形容他的工作状态，那便是：“迅捷如风，细致入微”。军秀是我的第三个师傅，因为年龄相近，无论在工作还是生活中，我感觉他就像我的舍友一样。有时候甚至忘记他比我大几岁。金虎师傅现在去了造粒，但仍在三厂工作。最近，他被人们称为“孩子王”，带领我们这些新人走到哪里就学到哪里，他似乎也不排斥这个称谓。尽管嘴上吐槽着世间万物，但他比任何人都起劲。我很喜欢他的说话方式和语气，从他的语言中总能获得无尽的力量。\n' +
              '初入厂时，我与杨工都是常白班，每天都可以向他学习新东西。无论是设备名字还是原理，我不懂的他总会耐心地解释甚至画图给我看。其他师傅们说杨工在炭黑行业工作了几十年，将一生都献给了炭黑。像杨工这样的员工，在炭黑厂有很多，每个人都值得被赞扬。\n' +
              '我并不爱好数学，但我觉得在描述三厂时，没有比"根号三"更合适的词了。在中西方文化中，数字3代表着幸运和美好，而“根号3”是一个无理数，一个无止境的循环。它没有确切的结果，却会持续不断地运行。就像三厂一样，它生生不息，不停地运转。而这个根号符号在中文里也像是一个"厂"字，将三厂的所有人凝聚在一起。\n' +
              '每个人都是不可或缺的一部分，承担着自己的责任，在班长和厂长的引领下有计划、有目标地运作。尽管看似无限漫长，但却有着明确的方向。根号符号下的一笔也象征着与企业的联系的起点。它没有与任何一个人连接中断。三厂从来不是一个独立的个体，它是企业的一部分，与企业紧密相连。就像我与三厂的每一个人一样，我们之间相互独立又紧密联系，这便是唯物辩证法的原理。所有这些组成了三厂，这也是属于我自己的“根号三”。\n' +
              '三厂的每一个人都值得我浓墨重彩地去描绘，文字的力量很大，大到寥寥几句便写下他们纵横生活岁月演绎人生的大半辈子。文字的力量很小，小到短短的文章装不下他们波澜壮阔冲州过府的人间过往。\n' +
              '井长巷，聚拢来是烟火，摊开来是人间。新的故事会在下一个秋冬春夏轮回中开始，有人爱晚风中绽放的花，小巷里乱窜的猫，独自一人看日落，看大海，每个人真诚而又不失浪漫地热爱着自己所热爱的。生活本来就是调味罐，至于是甜还是咸，就要看你加糖还是加盐了。\n' +
              '致三厂的每一位工作者，这就是我的根号三。',
          Content_en:"Love will not expire, like-minded people, always meet.\n" +
              "First came to carbon black factory three I have a lot of masters. As a newcomer, they taught me how to operate the equipment on the production line and shared their life experiences and philosophies in their spare time.\n" +
              "Chaoyang was my first teacher. He wore black-rimmed glasses and had a good accent. He worked longest in the oil region and seemed to know everything. He explained the pipeline of the oil district and told the history of the third plant. He is like a warrior who has traveled the world, adding \"pieces\" to those times for me. Chen Pei was my second master, and we always had an inexplicable affinity, perhaps because we were similar in size. Master Chen works seriously, with eight words to describe his work state, that is: \"as fast as the wind, meticulous.\" Jun Xiu is my third master, because he is close in age, whether in work or in life, I feel that he is like my roommate. Sometimes I forget he's a few years older than me. Master Jinhu has now gone to granulation, but still works in the third factory. Recently, he has been called the \"King of children\", leading us new people to learn wherever they go, and he does not seem to reject the title. Though he made fun of everything, he worked harder than anyone. I love his way of speaking and tone of voice, and I always get endless power from his words.\n" +
              "When I first entered the factory, Yang Gong and I were regular day shifts, and we could learn new things from him every day. Whether it is the name of the equipment or the principle, I do not understand he always patiently explain and even draw pictures for me to see. Other masters say Yang has worked in the carbon black industry for decades and devoted his life to it. Employees like Yang Gong, there are many in the carbon black plant, and everyone deserves praise.\n" +
              "I'm not a math person, but I don't think there's a better word to describe the third factory than the square root of three. In Chinese and Western culture, the number 3 represents luck and beauty, while the \"square root of 3\" is an irrational number, an endless cycle. It has no definite result, but it will continue to run. Just like the third Factory, it's alive and running. And the root sign is also like a \"factory\" in Chinese, bringing all the people of the third factory together.\n" +
              "Everyone is an integral part, bearing their own responsibilities, under the leadership of the class leader and the factory director to operate in a planned and targeted way. Though seemingly endless, it has a clear direction. The stroke under the radical symbol also symbolizes the starting point of contact with the business. It is not disconnected from any one person. The third factory is never an independent individual, it is a part of the enterprise, and closely connected with the enterprise. Like me and everyone in the Third Factory, we are independent and closely related to each other, and this is the principle of materialist dialectics. All of these make up the third factory, which is also my own \"square root three.\"\n" +
              "Every person in the third factory is worthy of my strong ink to describe, the power of words is very large, so large that a few words will write down their life and interpret most of the life. The power of words is very small, so small that a short article can not hold their magnificent rushing through the world's past.\n" +
              "Well long lane, gathering is fireworks, spread out is the world. The new story will begin in the next autumn, winter, spring and summer cycle, someone loves the flowers blooming in the evening wind, the cats running in the alleys, watching the sunset alone, watching the sea, everyone sincerely and romantically love their own love. Life is a seasoning pot, as to whether it is sweet or salty, it depends on whether you add sugar or salt.\n" +
              "To every worker in Factory three, this is my square root of three.",
          CreateTime: "2023-12-12 09:42",
          Img: require("../assets/img/StaffStyle2.jpg"),
          Title: '我的“根号三”',
          Title_en: "My square root of three",
          Type: 2,
        },
        {
          Id: 32,
          Content:'在机械轰鸣的厂房内，一顶穿梭在设备之间的红色安全帽格外耀眼。走近一看，原来是仪表主管李强正在检查调整6号线煤气调节阀的进气开度。\n' +
              '李强每天都要定时对现场仪表巡回检查，认真核对每项数据，因此他每天运动步数都达两万步。\n' +
              '“每天走那么多路，不累吗？”别人问他时，他总会笑着回答：“每天回到家只想美美地睡一觉，但上班后就要全力以赴。既是对自己负责，更是对公司负责。”在他的带领下，仪表检修班的小伙伴们也不甘落后，默默奉献。\n' +
              '安仑化工各装置车间，像李强一样默默付出的员工还有很多，他们致力于克服困难，为实现公司“产量盈利、安全生产零事故”双丰收目标努力奋斗着，为他们点赞！',
          Content_en: "In the machinery roar of the factory building, a red hard hat shuttling between the equipment is particularly dazzling. A closer look, the original instrument supervisor Li Qiang is checking and adjusting the intake of line 6 gas regulator valve.\n" +
              "Li Qiang has to regularly check the field instrument tour every day and carefully check each data, so he exercises 20,000 steps every day.\n" +
              "\"Aren't you tired of walking so much every day?\" When asked, he would answer with a smile: \"Every day I just want to go home and have a good sleep, but after going to work, I have to do my best.\" I am responsible not only to myself, but also to the company.\" Under his leadership, the small partners of the instrument maintenance class are not willing to lag behind and silently contribute.\n" +
              "Anlun Chemical plant workshops, like Li Qiang silently pay a lot of employees, they are committed to overcoming difficulties, in order to achieve the company's \"production profit, safe production zero accidents\" double harvest goal to struggle, praise for them!",
          CreateTime: "2023-12-12 09:42",
          Img: require("../assets/img/StaffStyle3.jpg"),
          Title: "仪表全能守卫者",
          Title_en:"Meter omnipotent defender",
          Type: 2,
        },
        {
          Id: 33,
          Content:'人生之初，自身的大戏已然开幕，其中的我等是为各自的主角，但大戏如何精彩，全在个人之努力，而我等的所扮演的角色、拥有的身份，亦时刻在变，如同千帆舟楫熙熙攘攘，自相来去。如我而言，角色变迁虽不频繁，但所拥有的身份已然很多。\n' +
              '入学前，我无忧无虑、无所顾忌，终日快哉乐哉。而入学后，作为学生，人生大戏也日渐丰富，各种喜怒悲忧滚滚而来，为成为他人好友而乐，为学习进退而烦，为某事生气不止，为某物忧愁不止。在此期间，也会有很多抉择，需要自身努力，需要勤于思考。\n' +
              '大学毕业，我选择了阳光集团作为我人生的下一站，作为今年的校招生，阳光为我们付出了许多，也制定了完善的培训计划帮助我们成长。进入公司业已半年之久，经历了很多培训，我逐步了解了公司的方方面面，也在想如何担当好员工这一角色。作为员工，这是我人生一场重要的角色变迁，它预示着我开启了人生的一个新阶段，此后我的人生大戏主旋律由学习转向工作，但学习仍旧不能停止。在工作中不断学习，不懂的问题随时求助，完成一项任务时做好规划，逐步完成。分到安仑化工后，经过了四个多月的培训，我们都分到了各自的岗位，成为了新的角色。未来，即将有很长一段时间都作为这个角色去展现我的人生大戏，还需得多多学习、持续进步，努力扮演好这一角色。\n' +
              '以后，我还会经历多次的角色变迁，身份更迭，这都是我人生的一部分，但这次的角色十分重要，公司在不断地发展，我们也需与时俱进，不断地提高自己的技能。未来，要不断地提升技术、提高产品的品质，助推公司成为真正的标杆企业，傲视群雄。公司正走进高速发展的轨道上，就像开始发动的高速列车，而我则是列车上的一颗螺丝钉，伴随着列车奔驰远方，同时也不断完善我的人生大戏。',
          Content_en: "At the beginning of life, our own drama has opened, in which we are the protagonists of their own, but how wonderful the drama is, all in personal efforts, and I play the role, have the identity, also always changing, like a thousand boats bustling, come and go from each other. For me, roles change infrequently, but they have a lot of identities.\n" +
              "Before I entered school, I was carefree, unscrupulous, and happy all day long. After entering the school, as a student, the drama of life is increasingly rich, all kinds of anger and sorrow rolling in, to become a friend of others and happy, for learning and trouble, for something angry more than, for something sad more than. During this period, there will be many choices that require your own efforts and diligent thinking.\n" +
              "After graduating from university, I chose Sunshine Group as my next stop in life. As this year's school enrollment, Sunshine has made a lot of efforts for us, and has also formulated a perfect training plan to help us grow. I have been in the company for half a year, and have experienced a lot of training. I gradually understand all aspects of the company, and I am also thinking about how to play the role of a good employee. As an employee, this is an important role change in my life, which indicates that I have opened a new stage in my life. After that, the main theme of my life has shifted from learning to work, but learning still can't stop. Keep learning in the work, do not understand the problem at any time to ask for help, to complete a task when planning, step by step. After being assigned to Anlun Chemical, after more than four months of training, we were assigned to our respective positions and became new roles. In the future, there will be a long period of time as this role to show my life drama, still need to learn a lot, continuous progress, and strive to play this role.\n" +
              "In the future, I will go through many role changes, identity changes, this is part of my life, but this role is very important, the company is constantly evolving, we need to keep pace with The Times and constantly improve their skills. In the future, we should continue to improve technology and improve the quality of products, and promote the company to become a real benchmarking enterprise, proud of the group. The company is entering the high-speed development of the track, just like the start of the high-speed train, and I am a screw on the train, accompanied by the train running far away, but also constantly improve my life drama.",
          Img: require("../assets/img/StaffStyle4.jpg"),
          Title: "人生大戏，角色变迁",
          Title_en:"Life drama, role changes",
          Type: 2,
        },
      ],
      thirdList: [
        {
          topic:'山西安仑化工有限公司突发环境事件应急预案（备案本）',
          title:'突发环境事件应急预案',
          date:'07.25.2025',
          path:'/static/pdf/32.pdf'
        },
        {
          topic:'安仑化工有限公司 2025 年轻油泄漏事故应急预案演练方案',
          title:'应急预案演练方案',
          date:'07.25.2025',
          path:'/static/pdf/31.pdf'
        },
        {
          topic:'2025年二季度污染源自行监测报告 2季度报告（有组织 水 噪声）',
          title:'污染源自行监测报告',
          date:'07.08.2025',
          path:'/static/pdf/29.pdf'
        },
        {
          topic:'2025年二季度污染源自行监测报告 2季度报告（无组织）',
          title:'污染源自行监测报告',
          date:'07.08.2025',
          path:'/static/pdf/28.pdf'
        },
        {
          topic:'山西安仑化工有限公司-应急预案备案证',
          title:'企业事业单位突发环境事件应急预案备案表',
          date:'07.08.2025',
          path:'/static/pdf/27.pdf'
        },
        {
          topic:'山西安仑化工危废应急预案（备案本）',
          title:'危废意外事故防范措施和应急预案',
          date:'07.08.2025',
          path:'/static/pdf/26.pdf'
        },
        {
          topic:'安仑化工25年1季度自行监测报告 QYZC25-71J01',
          title:'污染源自行监测报告',
          date:'03.24.2025',
          path:'/static/pdf/25.pdf'
        },
        {
          topic:'安仑三季度自行监测报告QYZC24-（主要一般排放口地下水噪声）',
          title:'主要一般排放口地下水噪声自行监测报告',
          date:'08.12.2024',
          path:'/static/pdf/20.pdf'
        },
        {
          topic:'安仑化工二季度自行监测报告主要一般排放口',
          title:'主要一般排放口自行监测报告',
          date:'06.01.2024',
          path:'/static/pdf/19.pdf'
        },
        {
          topic:'安仑化工二季度自行监测报告无组织环境空气',
          title:'无组织环境空气自行监测报告',
          date:'05.29.2024',
          path:'/static/pdf/18.pdf'
        },
        {
          topic:'安仑化工一季度自行监测报告QYZC24-71J01 1季度报告',
          title:'QYZC24-71J01自行监测报告',
          date:'03.12.2024',
          path:'/static/pdf/17.pdf'
        },
        {
          topic:'2023年度土壤及地下水自行监测报告',
          title:'土壤及地下水自行监测报告',
          date:'06.12.2023',
          path:'/static/pdf/1.pdf'
        },
        {
          topic:'2022年安仑土壤及地下水自行监测方案',
          title:'安仑土壤及地下水自行监测方案',
          date:'04.10.2023',
          path:"/static/pdf/2.pdf"
        },
        {
          topic:'2023年安仑自测-废水+地下水（2季度）',
          title:'RXJ（2023）ZC0210501-安仑自测-废水+地下水（2季度）',
          date:'06.11.2023',
          path:'/static/pdf/3.pdf'
        },
        {
          topic:'2023年安仑化工上半年废气（有+无+噪声+环境空气）',
          title:'RXJ（2023）ZC0210502安仑化工上半年废气（有+无+噪声+环境空气）',
          date:'06.12.2023',
          path:'/static/pdf/4.pdf'
        },
        {
          topic:'2023年安仑2季度自测（有+噪）',
          title:'RXJ（2023）ZC0210601安仑23年2季度自测（有+噪）',
          date:'06.11.2023',
          path:'/static/pdf/5.pdf'
        },
        {
          topic:'2023年安仑上半年自测',
          title:'RXJ（2023）ZC0210701  安仑上半年自测',
          date:'08.16.2023',
          path:'/static/pdf/6.pdf'
        },
        {
          topic:'2023年安仑1季度自测（有+噪） 022',
          title:'RXJ（2023）ZC0210101 安仑23年1季度自测（有+噪） 022',
          date:'04.03.2023',
          path:'/static/pdf/7.pdf'
        },
        {
          topic:'2023年安仑自测-废水+地下水（1季度）',
          title:'RXJ（2023）ZC0210102-安仑自测-废水+地下水（1季度）',
          date:'04.03.2023',
          path:'/static/pdf/8.pdf'
        },
        {
          topic:'2023年安仑分析报告',
          title:'2023山西安仑化工有限公司分析报告',
          date:'07.05.2023',
          path:'/static/pdf/9.pdf'
        },
        {
          topic:'2023年安仑1周期检测报告',
          title:'山西安仑化工有限公司_20231周期检测报告',
          date:'07.05.2023',
          path:'/static/pdf/10.pdf'
        },
        {
          topic:'安仑化工3季度环境质量自行监测报告',
          title:'山西安仑化工有限公司_20233季度环境质量自行监测报告',
          date:'10.19.2023',
          path:'/static/pdf/11.pdf'
        },
        {
          topic:'安仑化工2023年3季度污染物自行监测报告',
          title:'山西安仑化工有限公司_20233季度污染物自行监测报告',
          date:'10.19.2023',
          path:'/static/pdf/12.pdf'
        },
        {
          topic:'安仑化工2024年4季度无组织自行监测报告',
          title:'山西安仑化工有限公司_污染源自行监测报告',
          date:'12.26.2024',
          path:'/static/pdf/22.pdf'
        },
        {
          topic:'安仑化工2024年4季度有组织自行监测报告',
          title:'山西安仑化工有限公司_污染源自行监测报告',
          date:'12.21.2024',
          path:'/static/pdf/23.pdf'
        },

      ],
      fourthList: [
        {
          topic:'安仑化工反舞弊及举报投诉管理办法',
          title:'',
          date:'4.22.2022',
          path:'/static/pdf/13.pdf'
        },
        {
          topic:'安仑化工供应商行为准则',
          title:'',
          date:'04.22.2022',
          path:"/static/pdf/14.pdf"
        },
        {
          topic:'安仑化工2023年度社会责任报告',
          title:'',
          date:'04.22.2022',
          path:"/static/pdf/15.pdf"
        }
      ],
      fifthList: [
        {
          topic:'乌海安仑新技术有限公司碳基新材料综合应用项目(二期) 环境影响评价报批前公告',
          title:'',
          date:'03.12.2026',
          path:'/static/pdf/35.pdf'
        },
        {
          topic:'乌海安仑新技术有限公司碳基新材料综合应用项目(二期) 环境影响报告书征求意见稿（第二次公示）',
          title:'',
          date:'12.04.2025',
          path:'/static/pdf/34.pdf'
        },
        // {
        //   topic:'乌海安仑新技术有限公司碳基新材料综合应用项目（二期）环境影响评价公众参与信息公告（第一次公示）',
        //   title:'',
        //   date:'10.23.2025',
        //   path:'/static/pdf/33.pdf'
        // },
        {
          topic:'关于乌海安仑新技术有限公司碳基新材料综合应用项目环境影响评价的公示说明',
          title:'',
          date:'07.25.2025',
          path:'/static/pdf/30.pdf'
        },
        {
          topic:'乌海安仑新技术有限公司碳基新材料综合应用项目环竟影响评价报批前公告',
          title:'',
          date:'02.01.2025',
          path:'/static/pdf/24.pdf'
        },
        {
          topic:'第二次公示信息-乌海安仑新技术有限公司碳基新材料综合应用项目环境影响报告书征求意见稿',
          title:'',
          date:'12.30.2024',
          path:'/static/pdf/21.pdf'
        },
        {
          topic:'第一次公示信息-乌海安仑新技术有限公司26万吨年碳基新材料综合应用项目环评',
          title:'',
          date:'04.22.2022',
          path:'/static/pdf/16.pdf'
        }        
      ],
      
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      if (this.newstype == 1) {
        this.newsList = this.firstList;
      } else if(this.newstype == 2){
        this.newsList = this.secondList;
      } else if(this.newstype == 3){
        this.newsList = this.secondList;
      } else {
        this.newsList = this.fourthList;
      }
      // this.$http
      //   .get(`News?type=${this.newstype}&num=6`)
      //   .then((response) => {
      //     window.console.log(response);
      //     this.newsList = response.data;
      //     this.loading = false;
      //   })
      //   .catch(function (error) {
      //     window.console.log(error);
      //   });
    },
  },
  mounted() {
    this.loadData();
    // this.postData()
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    margin-bottom: 145px;
    //height: 1600px;

    &-content {
      // width: 1240px;
      // margin: 0 auto;
      background-color: #eeeeee;
      // border: 1px solid red;
      border: none;

      .content-nav {
        width: 500px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid #ee7a18;
        cursor: pointer;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: #ee7a18;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
           //width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          //margin: 10px auto;
          margin: 10px 0.1px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;
            text-indent: 2em;
            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    &-title {
      position: absolute;
      color: #ffffff;
      font-size: 45px;
      font-weight: 400;
      line-height: 300px;
      text-align: center;
      width: 100%;
    }
  }
}
</style>